<template>
  <div class="pageFooter a-ipx-bottom-border">
    <img :src="logoInfo.image" alt="" :class="logoInfo.class">
    <img
      :src="imageMap.banner"
      alt=""
      class="banner copy-button"
      v-if="showBanner&&!isChinaExpress"
      @click="bannerClickHandler">
    <div class="bannerBlock" v-if="isChinaExpress">
      <img
        :src="imageMap.banner20200218"
        alt="" class="smallBanner"
        @click="bannerClickHandler">
      <img
        :src="imageMap.banner20200217"
        alt="" class="smallBanner"
        @click="bannerClickHandler2">
    </div>
    <div class="text title">
      页面及数据接口接受转发、嵌入、调用及下载。
    </div>
    <div class="listItem">
      <div class="circle">
      </div>
      <div class="text">
        感谢目前共同搜集提供数据和服务的广大网友们
      </div>
    </div>
    <div class="listItem">
      <div class="circle">
      </div>
      <div class="text">
        相关数据均来自权威机构及媒体已公开信息，仅供参考，请谨慎核实
      </div>
    </div>
    <div class="listItem">
      <div class="circle">
      </div>
      <div class="text">
        错误反馈：zhoumh@133.cn、luxx@133.cn
      </div>
    </div>
    <div class="listItem">
      <div class="circle">
      </div>
      <div class="text">
        产品原型参考<a class="copy-button" @click="originToolClickHandler">[此工具]</a>，<!--
        -->感谢开发者
      </div>
    </div>
  </div>
</template>

<script>
  import imageMap  from '../../image-map.js';
  import env       from '@/utils/env.js';
  import clipboard from '@/utils/clipboard.js';

  let urlClipboard;

  urlClipboard = null;

  export default {
    data() {
      return {
        imageMap,

        showBanner : false
      };
    },

    computed : {
      logoInfo() {
        let result;

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        if ( ptid === 'dxys' ) {
          result = {
            image : imageMap.logo20200205,
            class : [ 'logo20200205' ]
          };
        } else if ( ptid === 'jegotrip' ) {
          result = {
            image : imageMap.logo20200206,
            class : [ 'logo20200206' ]
          };
        } else {
          result = {
            image : imageMap.logo,
            class : [ 'logo' ]
          };
        }

        return result;
      },

      isChinaExpress() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'huaxiaair';
      }
    },

    methods : {
      openLink( url ) {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        if (
          env.isWeixinMiniProgram
            || ptid === 'opponr'
            || ptid === 'zfbhb'
            || ptid === 'zfbgt'
        ) {
          urlClipboard = new clipboard( '.copy-button', {
            text : () => {
              return url;
            }
          } );

          urlClipboard.on( 'success', () => {
            this.$notify( {
              type    : 'success',
              message : '链接已复制，请打开浏览器粘贴查看。'
            } );
          } );

          urlClipboard.on( 'error', () => {
            this.$notify( {
              type    : 'error',
              message : '复制失败'
            } );
          } );
        } else {
          location.href = url;
        }
      },

      originToolClickHandler() {
        const url  = 'http://2019ncov.nosugartech.com/';

        this.openLink( url );
      },

      bannerClickHandler() {
        const url = 'https://unicom_trip.133.cn/city/?system=cjfcts';

        this.openLink( url );
      },

      bannerClickHandler2() {
        const url
          = 'https://hd.rsscc.cn/active/list.html'
          + '?groupId=6002329&hlfrom=gjky_hxhk';

        this.openLink( url );
      }
    },

    mounted() {
      setTimeout( () => {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        this.showBanner = !env.isWeixinMiniProgram && ptid !== 'ABC';
      }, 1000 );
    }
  };
</script>

<style scoped lang="scss">
  @import "./page-footer.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/home/page-footer.vue